// @flow

import { colors } from 'theme';

export const APPLICATION_STATUSES_LEGACY = {
  NEW: /* Status */ getText('New Application'),
  YES: /* Status */ getText('Move Forward'),
  MAYBE: /* Status */ getText('Under Consideration'),
  NO: /* Status */ getText('Screen Out')
};

export const APPLICATION_STATUSES_CURRENT = {
  APPLIED: /* Status */ getText('Applied'),
  UNDER_CONSIDERATION: /* Status */ getText('Under Consideration'),
  INTERVIEWING: /* Status */ getText('Interviewing'),
  MADE_OFFER: /* Status */ getText('Made Offer'),
  HIRED: /* Status */ getText('Hired'),
  DISQUALIFIED: /* Status */ getText('Disqualified ')
};

export const APPLICATION_STATUSES_ALL = {
  ...APPLICATION_STATUSES_LEGACY,
  ...APPLICATION_STATUSES_CURRENT
};

export const ATS_LINK_WARNINGS = {
  EMAIL: getText(
    `Did you mean to include an email address? Idealist won’t be able to track applicants who email you directly.`
  ),
  URL: getText(
    `Did you mean to include a URL? Idealist won’t be able to track applicants who apply off-site.`
  ),
  BOTH: getText(
    `Did you mean to include an email address or URL? Idealist won’t be able to track applicants who email you directly or apply off-site.`
  )
};

// before that date, referrers were not tracked, so we don't want to show wrong data
export const APPLICATION_REFERRER_SUPPORT_DATE = '2021-04-07T12:00:00.000Z';

export const COLOR_MAP = {
  // legacy statuses:
  NEW: {
    bg: colors.waterBlue,
    color: 'white'
  },
  YES: {
    bg: colors.turtleGreen,
    color: 'white'
  },
  NO: {
    bg: colors.silver,
    color: colors.charcoalGrey
  },
  MAYBE: {
    bg: colors.marigold,
    color: colors.charcoalGrey
  },
  // new statuses:
  APPLIED: {
    bg: colors.babyBlue,
    color: 'white'
  },
  UNDER_CONSIDERATION: {
    bg: colors.waterBlue,
    color: 'white'
  },
  INTERVIEWING: {
    bg: colors.fuchsia,
    color: 'white'
  },
  MADE_OFFER: {
    bg: colors.marigold,
    color: colors.charcoalGrey
  },
  HIRED: {
    bg: colors.turtleGreen,
    color: 'white'
  },
  DISQUALIFIED: {
    bg: colors.silver,
    color: colors.charcoalGrey
  }
};

export const getColor = (key: string) => COLOR_MAP[key] || COLOR_MAP.APPLIED;
